
export const ABNORMAL_MSG = {
    NETWORK_OFFLINE: '网络连接异常，请检查网络', //断网
    SERVER_ERROR: '服务器异常，请稍后重试', // 服务异常兜底文案
}

export const codeTransferName = (code, tenantId) => {
    const PRIVACYNAMEMAP = {
        'driverUserAgreement': [801589, 800357].includes(tenantId*1) ? '代驾平台个人信息保护和隐私政策' : '用户协议',
        'driverPrivacyAgreement': [801589, 800357].includes(tenantId*1) ? '代驾平台服务协议' : '隐私协议',
        'driverWithdrawalAgreement': '提现协议',
        'driverRecordingAgreement': '录音保护协议',
        'softUseAgreement': '软件使用协议',
        'softUserProtectPrivacyAgreement': '软件个人信息保护及隐私政策'
    }
    return PRIVACYNAMEMAP[code]
}